export const settingsTranslations = {
    en: {
        settingsTitle: 'System Settings',
        settingsDescription: 'Configure your restaurant system settings',
        restaurantSettings: 'Restaurant Settings',
        printerSettings: 'Printer Settings',
        taxSettings: 'Tax Settings',
        taxConfig: 'Tax Configuration',
        taxPercentage: 'Tax Percentage',
        includedInPrice: 'Tax Included in Price',
        showTaxNumber: 'Show Tax Number on Receipt',
        interfaceSettings: 'Interface Settings',
        receiptSettings: 'Receipt Settings',
        userSettingsTitle: 'User Settings',
        userConfig: 'User Configuration',
        
        // Restaurant Settings
        phone: 'Phone Number',
        address: 'Address',
        addressAr: 'Address (Arabic)',
        restaurantNameAr: 'Restaurant Name (Arabic)',
        taxNumber: 'Tax Number',
        commercialRegistration: 'Commercial Registration',
        
        // Printer Settings
        printerConfig: 'Printer Configuration',
        printerName: 'Printer Name',
        selectPrinter: 'Select a printer',
        printerType: 'Printer Type',
        thermal: 'Thermal',
        dotMatrix: 'Dot Matrix',
        inkjet: 'Inkjet',
        paperSize: 'Paper Width',
        fontSize: 'Font Size',
        showLogo: 'Show Logo',
        autoPrint: 'Auto Print',
        qzTrayConfig: 'QZ Tray Configuration',
        certificate: 'Certificate',
        privateKey: 'Private Key',
        autoHeight: 'Auto Height',
        paperHeight: 'Paper Height',
        printCopies: 'Number of Copies',
        openDrawerAfterPrint: 'Open Cash Drawer After Print',
        
        // Interface Settings
        interfaceConfig: 'Interface Configuration',
        defaultLanguage: 'Default Language',
        english: 'English',
        arabic: 'Arabic',
        itemsPerPage: 'Items Per Page',
        currencySymbol: 'Currency Symbol',
        
        // Receipt Settings
        receiptConfig: 'Receipt Configuration',
        showCustomerInfo: 'Show Customer Information',
        showOrderNumber: 'Show Order Number',
        showQrCode: 'Show QR Code',
        footerText: 'Footer Text (English)',
        footerTextAr: 'Footer Text (Arabic)',

        // Delivery Settings
        deliverySettings: 'Delivery Settings',
        deliveryConfig: 'Delivery Configuration',
        enableDelivery: 'Enable Delivery',
        deliveryFee: 'Delivery Fee',
        feeType: 'Fee Type',
        minimumOrderAmount: 'Minimum Order Amount',
        minOrderAmount: 'Minimum Order Amount',
        maxDeliveryDistance: 'Maximum Delivery Distance',
        maxDeliveryDistanceHelp: 'Maximum distance (in kilometers) for delivery orders',

        // Table Service Settings
        tableServiceSettings: 'Table Service Settings',
        enableTableService: 'Enable Table Service',
        serviceCharge: 'Service Charge',
        chargeType: 'Charge Type',
        serviceChargeType: 'Service Charge Type',
        serviceChargeAmount: 'Service Charge Amount',
        maxServiceCharge: 'Maximum Service Charge',
        maxServiceChargeHelp: 'Maximum amount to charge for service (only applies to percentage-based charges)',
        percentage: 'Percentage',
        fixed: 'Fixed Amount',
    },
    ar: {
        settingsTitle: 'إعدادات النظام',
        settingsDescription: 'تكوين إعدادات نظام المطعم',
        restaurantSettings: 'إعدادات المطعم',
        printerSettings: 'إعدادات الطابعة',
        taxSettings: 'إعدادات الضريبة',
        taxConfig: 'تكوين الضريبة',
        taxPercentage: 'نسبة الضريبة',
        includedInPrice: 'الضريبة مشمولة في السعر',
        showTaxNumber: 'إظهار الرقم الضريبي على الفاتورة',
        interfaceSettings: 'إعدادات الواجهة',
        receiptSettings: 'إعدادات الفاتورة',
        userSettingsTitle: 'إعدادات المستخدمين',
        userConfig: 'تكوين المستخدم',
        
        // Restaurant Settings
        phone: 'رقم الهاتف',
        address: 'العنوان',
        addressAr: 'العنوان (عربي)',
        restaurantNameAr: 'اسم المطعم (عربي)',
        taxNumber: 'الرقم الضريبي',
        commercialRegistration: 'السجل التجاري',
        
        // Printer Settings
        printerConfig: 'تكوين الطابعة',
        printerType: 'نوع الطابعة',
        thermal: 'حرارية',
        dotMatrix: 'نقطية',
        inkjet: 'نفاثة الحبر',
        paperSize: 'عرض الورق',
        fontSize: 'حجم الخط',
        showLogo: 'إظهار الشعار',
        autoPrint: 'طباعة تلقائية',
        printerName: 'اسم الطابعة',
        selectPrinter: 'حدد طابعة',
        qzTrayConfig: 'أعداد QZ Tray',
        certificate: 'شهادة',
        privateKey: 'المتاح الخاص',
        autoHeight: 'أتوماتيك',
        paperHeight: 'الطول',
        printCopies: 'عدد النسخ',
        openDrawerAfterPrint: 'فتح الدرج بعد الطباعة',
        
        // Interface Settings
        interfaceConfig: 'تكوين الواجهة',
        defaultLanguage: 'اللغة الافتراضية',
        english: 'الإنجليزية',
        arabic: 'العربية',
        itemsPerPage: 'عدد المنتجات في الصفحة',
        currencySymbol: 'رمز العملة',
        
        // Receipt Settings
        receiptConfig: 'تكوين الفاتورة',
        showCustomerInfo: 'إظهار معلومات العميل',
        showOrderNumber: 'إظهار رقم الطلب',
        showQrCode: 'إظهار رمز QR',
        footerText: 'نص التذييل (بالإنجليزية)',
        footerTextAr: 'نص التذييل (بالعربية)',

        // Delivery Settings
        deliverySettings: 'إعدادات التوصيل',
        deliveryConfig: 'تكوين التوصيل',
        enableDelivery: 'تفعيل التوصيل',
        deliveryFee: 'رسوم التوصيل',
        feeType: 'نوع الرسوم',
        minimumOrderAmount: 'الحد الأدنى للطلب',
        minOrderAmount: 'الحد الأدنى للطلب',
        maxDeliveryDistance: 'الحد الأقصى لمسافة التوصيل',
        maxDeliveryDistanceHelp: 'الحد الأقصى للمسافة (بالكيلومتر) لطلبات التوصيل',

        // Table Service Settings
        tableServiceSettings: 'إعدادات خدمة الطاولة',
        enableTableService: 'تفعيل خدمة الطاولة',
        serviceCharge: 'رسوم الخدمة',
        chargeType: 'نوع الرسوم',
        serviceChargeType: 'نوع رسوم الخدمة',
        serviceChargeAmount: 'قيمة رسوم الخدمة',
        maxServiceCharge: 'الحد الأقصى لرسوم الخدمة',
        maxServiceChargeHelp: 'الحد الأقصى لرسوم الخدمة (ينطبق فقط على الرسوم النسبية)',
        percentage: 'نسبة مئوية',
        fixed: 'مبلغ ثابت',
    }
};
